import store from '../../init/store.js'
import {getTeamHpRating} from '../analysis/team-analysis-utilities.js'
import {setBattleValue} from '../../redux-actions/battle-actions.js'

export function trackHpOfTeams() {

  const teams = store.getState().battle.teams;
  const combatants = store.getState().battle.combatants;

  const teamOneCombatants = teams["one"].combatantIds.map(combId => {
    return combatants[combId];
  });
  const teamTwoCombatants = teams["two"].combatantIds.map(combId => {
    return combatants[combId];
  });


  const report = [
    getTeamHpRating(teamOneCombatants),
    getTeamHpRating(teamTwoCombatants)
  ];

  //Add report to list of HP reports (will use at the end of battle for tracking)
  setBattleValue({
    hpRatingsOfTeamsPerTurnSeries: [
      ...store.getState().battle.hpRatingsOfTeamsPerTurnSeries,
      report
    ]
  });
}


// WEBPACK FOOTER //
// ./src/battle/analysis/track-hp-of-teams.js